import { render, staticRenderFns } from "./WalkthroughModal.vue?vue&type=template&id=3356edcd&"
import script from "./WalkthroughModal.vue?vue&type=script&lang=ts&"
export * from "./WalkthroughModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports